import styles from './expense-message.module.css';

interface Props {
	amount1: number;
	amount2: number;
}
export default function WarningMessage({ amount1, amount2 }: Props) {
	return <p className={styles.message}>Note: Remaining balance to match {(amount1 - amount2).toFixed(2)}</p>;
}
